import * as React from 'react';
import { Input, Select } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

import StaticView from './StaticView';
import * as intl from 'react-intl-universal';
import * as update from 'immutability-helper';
const Option = Select.Option;

interface iOption {
    label: string | JSX.Element;
    value: string;
}

export default class SelectInput extends React.Component<any> {
    static fieldName = 'select';
    static type = 'Select';
    private select: HTMLElement;

    /**
     * 选择框变化控制
     * @param value
     */
    onChangeHandler = (val: string) => {
        const { value = {}, onChange } = this.props;
        let newData = update(value,{ selectValue: { $set: val}});
        val !== 'other' && (newData = update(newData,{ otherInput: { $set: ''}}));
        onChange && onChange(newData);
    };

    /**
     * 输入框变化控制
     * @param value
     */
    onInputHandler = (val: any) => {
        const { value = {}, onChange } = this.props;
        let newData = update(value,{ otherInput: { $set: val}});
        onChange && onChange(newData);
    };

    /**
     * 失焦控制
     */
    onBlurHandler = () => {
        const { onBlur, value, onChange } = this.props;
        onBlur ? onBlur(value) : onChange && onChange(value);
    };

    /**
     * 静态数据展示处理
     * @param val
     */
    adaptHandler = (val: any) => {
        const selectValue = val.selectValue || '';
        const otherInput = val.otherInput || '';
        const { options } = this.props;
        const display = options && options.filter(({ value }: iOption) => selectValue === value);
        return (display && display.length) && (`${selectValue === 'other' ? `(${display[0].label})` : display[0].label} ${selectValue === 'other' ? `${otherInput || ''}` : '' }`);
    };

    render() {
        const { value={}, initialValue, placeholder, options, allowClear, disabled, getPopupContainer, size, staticView, dropdownStyle} = this.props;
        const selectValue = value.selectValue || '';
        const otherInput = value.otherInput || '';
        return (
            (staticView && disabled) ? <StaticView display={initialValue || value} adaptFn={this.adaptHandler}/>
            :
                <div ref={(ctx: HTMLElement) => this.select = ctx} style={{ position: 'relative' }}>
                   <Select onChange={this.onChangeHandler}
                          dropdownStyle={dropdownStyle}
                          onBlur={this.onBlurHandler}
                          placeholder={placeholder}
                          getPopupContainer={getPopupContainer && (() => this.select)}
                          allowClear={allowClear}
                          disabled={disabled}
                          value={selectValue}
                          size={size}
                          showSearch={Array.isArray(options) && (options.length > 10)}
                          optionFilterProp="children"
                          filterOption={(input: string, option: any) => {
                              const text = option.props.children;
                              return (typeof text === 'string' ? text : text[0]).toLowerCase().includes(input.toLowerCase());
                          }}
                    >
                        {options && options.map((item: any, index: number) => {
                            return item.hasOwnProperty('value')
                                ? <Option key={item.value + index} value={item.value} disabled={item.disabled} className={item.className} style={{verticalAlign:"middle",width:"100%"}}>
                                    {item.label}
                                    {item.selectedPoint
                                        ? <CheckOutlined style={{color:"#096dd9",marginTop:"8px",float:"right"}} />
                                        : null
                                    }
                                </Option>
                                : <Option key={`form-sl-op-${index}`} value={item}>{item + 1}</Option>;
                        })}
                    </Select>
                    {selectValue === 'other' && (<Input
                            value={otherInput}
                            onBlur={this.onBlurHandler}
                            placeholder={intl.get('Hint.Input', { field: intl.get('Global.Other') })}
                            onChange={(e) => this.onInputHandler(e.target.value)}
                            style={{ marginTop: 5 }}></Input>)}
                </div>
        );
    }
}
